export function convertDateToLocalDate(dateStr?: string): Date | undefined {
    if (typeof dateStr === 'string' && dateStr.length > 0) {
        const date = new Date(dateStr);
        return new Date(date.valueOf() + date.getTimezoneOffset() * 60 * 1000);
    }
}

export function calculateDueDate(invoiceDate: Date, terms: number): Date {
    let returnDate = new Date();
    returnDate.setDate(invoiceDate.getDate() + terms);
    return returnDate;
}
